import type { DashboardSpec } from "../dashboard/catalog"

export type DashRequestIntent = "create" | "edit"

const NEW_DASHBOARD_REQUEST_PATTERNS = [
  /\b(?:skapa|bygg|gör|starta|generera)\b.{0,32}\b(?:en\s+)?(?:helt\s+)?(?:ny|nytt|separat)\s+(?:dash(?:board)?|instrumentpanel)\b/i,
  /\b(?:create|build|make|start|generate)\b.{0,32}\b(?:a\s+)?(?:(?:brand[-\s]+)?new|separate)\s+dashboard\b/i,
  /\b(?:erstelle|erstellen|baue|bauen|starte|starten|generiere|generieren)\b.{0,32}\b(?:ein(?:e|en|es)?\s+)?(?:ganz\s+)?(?:neu(?:e|en|es)?|separat(?:e|en|es)?)\s+dashboard\b/i,
  /(?:^|\s)(?:luo|rakenna|aloita|generoi)\b.{0,32}(?:kokonaan\s+)?(?:uusi|erillinen)\s+(?:dashboard|koontinäyttö|koontinäkymä)(?:\s|$|[.!?,])/i,
  /\b(?:opprett|lag|bygg|start|generer)\b.{0,32}\b(?:(?:et|en)\s+)?(?:helt\s+)?(?:nytt?|separat)\s+(?:dashboard|dashbord)\b/i,
]

const NEGATED_NEW_DASHBOARD_PATTERNS = [
  /\b(?:skapa|bygg|gör|starta|generera)\s+(?:absolut\s+)?(?:inte|ingen)\b/i,
  /\b(?:do\s+not|don't|not)\s+(?:create|build|make|start|generate)\b/i,
  /\b(?:erstelle|erstellen|baue|bauen|generiere|generieren)\b.{0,16}\b(?:nicht|kein(?:e|en|es)?)\b/i,
  /(?:^|\s)(?:älä|ei)\s+(?:luo|rakenna|generoi)\b/i,
  /\bikke\b.{0,24}\b(?:opprett|lag|bygg|generer)\b/i,
]

/**
 * Detect a user explicitly asking for a separate dashboard document while
 * they are already chatting with an existing one. This is intentionally
 * narrower than a generic mention of "new dashboard": false positives here
 * would split ordinary edit turns into new saved documents.
 */
export function isExplicitNewDashboardRequest(question: string): boolean {
  const normalized = question.trim().replace(/\s+/g, " ")
  if (!normalized) return false
  if (NEGATED_NEW_DASHBOARD_PATTERNS.some((pattern) => pattern.test(normalized))) return false
  return NEW_DASHBOARD_REQUEST_PATTERNS.some((pattern) => pattern.test(normalized))
}

export function getDashRequestIntent(input: {
  currentDashboardId: string | null
  currentDashboardSpec: DashboardSpec | null
}): DashRequestIntent {
  return input.currentDashboardId || input.currentDashboardSpec ? "edit" : "create"
}
